export const form = {
  heading: "Fill Up Your Form",
  subTitle:
    "All our FREE TRIAL servers are in Germany. If you wish to run a production site in Switzerland, kindly contact us for the Premium Plan.",
};
